import { Route, Routes, useLocation, useRoutes } from 'react-router-dom';
import { Top } from '@/features/top';
import { Channel } from '@/features/channels/[cid]';
import { ChannelPost } from '@/features/channels/[cid]/channel_posts/[id]';
import { ModalChannelPost } from '@/features/@modal/channels/[cid]/channel_posts/[id]';
import { Error404 } from '@/features/404';
import { usePageTracking } from '@/hooks/gtm/usePageTracking';
import { useCsrfToken } from '@/hooks/api/useCsrfToken';
import { useEffect } from 'react';
import { ChannelPosts } from '@/features/channel_posts';
import { MovieEmbed } from '@/features/embed/[cid]/[id]';
import { NewestMovieEmbed } from '@/features/embed/[cid]';
import { RankingAd } from '@/features/embed/ad/ranking';

export const AppRouter = () => {
  const location = useLocation();
  const state = location.state as { backgroundLocation?: Location };
  const { refetch } = useCsrfToken();

  usePageTracking();

  useEffect(() => {
    // 埋め込みバナーの場合はcsrfトークンを取得しない
    if (location.pathname !== '/embed/ad/ranking') {
      refetch();
    }
  }, []);

  return (
    <>
      <Routes location={state?.backgroundLocation || location}>
        <Route path="/" element={<Top />} />
        <Route path="/channels/:cid" element={<Channel />} />
        <Route path="/channels/:cid/channel_posts/:id" element={<ChannelPost />} />
        <Route path="/channel_posts" element={<ChannelPosts />} />
        <Route path="/embed/ad/ranking" element={<RankingAd />} />
        <Route path={'/embed/:cid/:id'} element={<MovieEmbed />} />
        <Route path={'/embed/:cid'} element={<NewestMovieEmbed />} />
        <Route path="404" element={<Error404 />} />
        <Route path="*" element={<Error404 />} />
      </Routes>

      {/* https://stackblitz.com/github/remix-run/react-router/tree/main/examples/modal?file=src%2FApp.tsx */}
      {state?.backgroundLocation && (
        <Routes>
          <Route path="/channels/:cid/channel_posts/:id" element={<ModalChannelPost />} />
        </Routes>
      )}
    </>
  );
};
